import { defineComponent, computed } from 'vue';
import { useStore } from 'vuex';
import { ListItem } from '@/components';
var fetcStock = function (dispatch, symbol) {
    return dispatch('fetchDataStocks', { symbol: symbol });
};
export default defineComponent({
    name: 'page-stock',
    components: {
        ListItem: ListItem,
    },
    props: {
        symbol: {
            type: String,
            required: true,
        },
    },
    setup: function (props) {
        var _a = useStore(), getters = _a.getters, dispatch = _a.dispatch;
        var getSymbolStock = computed(function () {
            return getters.getStocks.find(function (stock) { return stock.symbol === props.symbol; });
        });
        if (!getSymbolStock.value) {
            fetcStock(dispatch, props.symbol);
        }
        return {
            getSymbolStock: getSymbolStock,
        };
    },
});
